/**
 * @param {string} str Input.
 * @returns {Uint8Array}.
 */
export default function fromBase64(str: string): Uint8Array {
  // atob creates a "raw string" where each character is interpreted as a byte.
  const bytes = window.atob(str.replace(/-/g, '+').replace(/_/g, '/'));
  const result = new Uint8Array(bytes.length);
  for (let i = 0; i < bytes.length; i += 1) {
    result[i] = bytes.charCodeAt(i);
  }
  return result;
}
